import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import RightPanel from "@/components/RightPanel";
import AIChat from "@/components/AIChat";
import NewModal from "@/components/NewModal";
import { Toaster } from "sonner";
import { PanelProvider } from "@/context/PanelContext";

export default function Layout() {
  const [newOpen, setNewOpen] = useState(false);
  const [newType, setNewType] = useState("task");
  const openNew = (type) => {
    setNewType(typeof type === "string" ? type : "task");
    setNewOpen(true);
  };

  return (
    <PanelProvider>
      <div className="min-h-screen bg-slate-50">
        <Sidebar onNew={() => openNew("task")} />
        <div className="md:ml-64 md:mr-96 min-h-screen flex flex-col">
          <Header />
          <main className="pb-12 flex-1">
            <Outlet context={{ openNew }} />
          </main>
        </div>
        <AIChat />
        <RightPanel />
        <NewModal open={newOpen} onOpenChange={setNewOpen} defaultType={newType} />
        <Toaster richColors position="top-center" />
      </div>
    </PanelProvider>
  );
}
